import Gender from "@/models/Gender";


export default {
    state: {
        gender: new Gender(),
        genders: new Array(),
    },
    getters:{
        getGender(state){
            return state.gender;
        },
        getGenders(state){
            return state.genders
        },
    },
    mutations: {
        setGender(state,dado){
            state.gender = JSON.parse(JSON.stringify(dado? dado : new Gender()));
        },
        setGenders(state,dados){
            state.genders = dados
        },
    },
    actions: {
        setGender({commit}, dado){
            commit('setGender', dado);
        },
        setGenders({commit}, dados){
            commit('setGenders', dados);
        }
    },
}